export class UserMatchesFiltersRequest {
  is_exited_filter_active: boolean = false;
  is_exited: boolean = false;
}
